<script setup lang="ts">
import { Form, Head } from "@inertiajs/vue3";

import AuthCardShell from "@/components/auth-card-shell.vue";
import { Button } from "@/components/ui/button/index";
import { identityPasswordResetPath } from "@/routes";

defineOptions({ inheritAttrs: false });
interface Props {
  sid: string;
  email: string;
}

defineProps<Props>();
</script>

<template>
  <Head title="Restablecer contraseña" />

  <AuthCardShell
    title="Restablecer contraseña"
    description="Definí una nueva contraseña para tu cuenta."
  >
    <Form
      :action="identityPasswordResetPath()"
      method="put"
      disable-while-processing
      class="inert:pointer-events-none inert:opacity-80"
      :reset-on-error="['password', 'password_confirmation']"
      #default="{ errors, processing }"
    >
      <input type="hidden" name="sid" :value="sid" />

      <div class="space-y-4">
        <div class="space-y-1.5">
          <label for="reset-email-readonly" class="text-sm font-medium"
            >Correo electrónico</label
          >
          <input
            id="reset-email-readonly"
            name="email"
            type="email"
            readonly
            :value="email"
            class="input-field-muted"
          />
          <p v-if="errors.email" class="text-sm text-destructive">
            {{ errors.email }}
          </p>
        </div>

        <div class="space-y-1.5">
          <label for="new-password" class="text-sm font-medium"
            >Nueva contraseña</label
          >
          <input
            id="new-password"
            name="password"
            type="password"
            required
            autocomplete="new-password"
            placeholder="Nueva contraseña"
            class="input-field"
          />
          <p v-if="errors.password" class="text-sm text-destructive">
            {{ errors.password }}
          </p>
        </div>

        <div class="space-y-1.5">
          <label for="new-password-confirm" class="text-sm font-medium"
            >Confirmar contraseña</label
          >
          <input
            id="new-password-confirm"
            name="password_confirmation"
            type="password"
            required
            autocomplete="new-password"
            placeholder="Confirmar contraseña"
            class="input-field"
          />
          <p
            v-if="errors.password_confirmation"
            class="text-sm text-destructive"
          >
            {{ errors.password_confirmation }}
          </p>
        </div>

        <Button type="submit" :disabled="processing" class="w-full">
          {{ processing ? "Actualizando..." : "Restablecer contraseña" }}
        </Button>
      </div>
    </Form>
  </AuthCardShell>
</template>
